import ListContainer from '../../lib/ListContainer'

async function listFiscalYears() {
  const path = '/api/asebi/fiscal_years';
  const resp = await fetch(path);
  return await resp.json();
}

export default listFiscalYears;
